export default {
    'WORKERS.SEARCH.PLACEHOLDER': 'Search by name',
    'WORKER.DETAILS': 'Worker details',
    'WORKER.NO.WORKER': 'No workers yet',
    'WORKER.UNCONFIRMED': 'Unconfirmed users',
    'WORKER.CONFIRMED': 'Confirmed users',
    'WORKER.EMAIL.TAKEN': 'Email has already been taken',
    'WORKER.POPUP.SUCCESS.EDIT.MESSAGE': 'Profile has been updated',
};
